module.exports = __webpack_public_path__ + "img/timbreTool.2a35ee19.png";